function matchMedia(mediaQuery: string) {
  return typeof window !== "undefined" && window.matchMedia
    ? window.matchMedia(mediaQuery).matches
    : false;
}

export default matchMedia;
